import { render, staticRenderFns } from "./OutstandingDaysInsurer.vue?vue&type=template&id=5c9edaaf"
import script from "./OutstandingDaysInsurer.vue?vue&type=script&lang=js"
export * from "./OutstandingDaysInsurer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports